<!-- user-list.component.html -->

<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <!-- jss-creation.component.html -->
                    <div *ngIf="showTable; else formView">
                        <div class="mb-4 d-md-flex align-items-center justify-content-between">
                            <!-- You can add other UI elements here if needed -->
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="offset-md-2 col-md-6">
                                        <h4 class="text-center font-bold font-up danger-text">Job Specification System
                                            for Creation</h4>
                                    </div>
                                    <div class="mb-2 col-md-4">
                                        <input type="text" placeholder="Search Customer by name || Ref No || Job Type"
                                            class="form-control mb-3" [(ngModel)]="searchText" (input)="onSearch()">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button (click)="deleteSelectedEntries()" class="btn btn-outline-danger mb-3"><i
                                class="feather icon-trash-2"></i></button>

                        <div class="table-responsive" style="max-height: 500px; overflow-y: auto;">
                            <table class="table mb-0 table-centered table-bordered">
                                <thead>
                                    <tr>
                                        <th><input type="checkbox" id="selectAllCheckbox"
                                                (change)="selectAllChanged($event)"></th>
                                        <th>Ticket No</th>
                                        <th>Ref No</th>
                                        <th>PO No</th>
                                        <th (click)="sortByColumn('clientName')">Client Name
                                            <i class="feather icon-arrow-up"
                                                *ngIf="sortColumn === 'clientName' && sortDirection === 'asc'"></i>
                                            <i class="feather icon-arrow-down"
                                                *ngIf="sortColumn === 'clientName' && sortDirection === 'desc'"></i>
                                        </th>
                                        <th>Job Name</th>
                                        <th>Job Type</th>
                                        <th>Order Kgs</th>
                                        <th>FD Option</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let order of paginatedOrderList">
                                        <td><input type="checkbox" class="rowCheckbox" [attr.data-id]="order._id"></td>
                                        <td>{{ order.ticketno }}</td>
                                        <td>{{ order.refNo }}</td>
                                        <td>{{ order.poNo }}</td>
                                        <td>{{ order.clientName }}</td>
                                        <td>{{ order.jobName }}</td>
                                        <td>{{ order.jobType }}</td>
                                        <td>{{ order.orderKgs }}</td>
                                        <td>{{ order.fdOption }}</td>
                                        <td>
                                            <button type="button" routerLink="/jssCreation/{{order._id}}"  title="Create Jss">JSS<i class="feather icon-edit"></i></button>

                                            <!-- <button routerLink="/jssCreation/{{order._id}}" type="button" class="btn btn-outline-dark  btn-sm">JSS<i class="feather icon-edit"></i></button> -->
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="pagination-container">
                            <div class="pagination mt-3 d-flex justify-content-between align-items-center">
                                <div>
                                    <p>Showing {{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ totalItems
                                        }}</p>
                                </div>
                                <div class="d-flex">
                                    <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)"
                                        [ngClass]="{'disabled': currentPage === 1}">
                                        <i class="feather icon-chevrons-left"></i>
                                    </a>
                                    <ng-container *ngFor="let page of getNumberRange(ceil(totalItems / itemsPerPage))">
                                        <a class="pagination-circle" [class.active]="currentPage === page"
                                            (click)="onPageChange(page)">
                                            {{ page }}
                                        </a>
                                        <span *ngIf="page < ceil(totalItems / itemsPerPage)"
                                            class="page-number-space"></span>
                                    </ng-container>
                                    <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)"
                                        [ngClass]="{'disabled': currentPage === ceil(totalItems / itemsPerPage)}">
                                        <i class="feather icon-chevrons-right"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>



                    <ng-template #formView>
                        <div class="mb-4 d-md-flex align-items-center justify-content-between">

                            <div>
                                <h3>Complete Job info and Save</h3>
                                <p>Kindly check all the information and correct all mistakes and update, then save</p>
                            </div>
                        </div>
                        <div class="form-card">
                            <form (ngSubmit)="submitForm()" [formGroup]="updateJssForm">
                                <div class="row">

                                    <div class="col form-group mb-3">
                                        <label for="clientName" class="form-label">Client Name</label>
                                        <input type="text" formControlName="clientName" id="clientName"
                                            class="form-control" readonly disabled />
                                        <div *ngIf="updateJssForm.get('clientName')?.invalid && (updateJssForm.get('clientName')?.dirty || updateJssForm.get('clientName')?.touched)"
                                            class="text-danger">
                                            <!-- Add specific validation messages here if needed -->
                                            Enter Correct Client Name
                                        </div>
                                    </div>

                                    <div class="col form-group mb-3">
                                        <label for="ticketno" class="form-label">Ticket No.</label>
                                        <input type="text" formControlName="ticketno" id="ticketno" class="form-control"
                                            readonly disabled />
                                        <div *ngIf="updateJssForm.get('ticketno')?.invalid && (updateJssForm.get('ticketno')?.dirty || updateJssForm.get('ticketno')?.touched)"
                                            class="text-danger">
                                            <!-- Add specific validation messages here if needed -->
                                            Enter Correct Ticket Number

                                        </div>
                                    </div>



                                    <div class="col form-group mb-3">
                                        <label for="jobType" class="form-label">Job Type</label>
                                        <input type="text" formControlName="jobType" id="jobType" class="form-control"
                                            readonly disabled />
                                        <div *ngIf="updateJssForm.get('jobType')?.invalid && (updateJssForm.get('jobType')?.dirty || updateJssForm.get('jobType')?.touched)"
                                            class="text-danger">
                                            <!-- You might not need validation here since the field is read-only -->
                                            Enter Correct Job Type

                                        </div>
                                    </div>

                                    <div class="col form-group mb-3">
                                        <label for="orderKgs" class="form-label">Order Qty</label>
                                        <input type="text" formControlName="orderKgs" id="orderKgs" class="form-control"
                                            readonly disabled />
                                        <div *ngIf="updateJssForm.get('orderKgs')?.invalid && (updateJssForm.get('orderKgs')?.dirty || updateJssForm.get('orderKgs')?.touched)"
                                            class="text-danger">
                                            <!-- You might not need validation here since the field is read-only -->
                                        </div>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="refNo" class="form-label">Ref No.</label>
                                        <input type="text" formControlName="refNo" id="refNo" class="form-control"
                                            readonly disabled />
                                        <div *ngIf="updateJssForm.get('refNo')?.invalid && (updateJssForm.get('refNo')?.dirty || updateJssForm.get('refNo')?.touched)"
                                            class="text-danger">
                                            <!-- Add specific validation messages here if needed -->
                                            Enter Correct Ref

                                        </div>
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="poNo" class="form-label">P.O No.</label>
                                        <input type="text" formControlName="poNo" id="poNo" class="form-control"
                                            readonly disabled />
                                        <div *ngIf="updateJssForm.get('poNo')?.invalid && (updateJssForm.get('poNo')?.dirty || updateJssForm.get('poNo')?.touched)"
                                            class="text-danger">
                                            <!-- You might not need validation here since the field is read-only -->
                                            Enter Correct PO Number

                                        </div>
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="ddDate" class="form-label">Delivery Date</label>
                                        <input type="date" formControlName="ddDate" id="ddDate" class="form-control"
                                            readonly disabled />
                                        <div *ngIf="updateJssForm.get('ddDate')?.invalid && (updateJssForm.get('ddDate')?.dirty || updateJssForm.get('ddDate')?.touched)"
                                            class="text-danger">
                                            <!-- You might not need validation here since the field is read-only -->
                                            Enter Correct PO Number

                                        </div>
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="jobName" class="form-label">Job Name</label>
                                        <input type="text" formControlName="jobName" id="jobName" class="form-control"
                                            readonly disabled />
                                        <div *ngIf="updateJssForm.get('jobName')?.invalid && (updateJssForm.get('jobName')?.dirty || updateJssForm.get('jobName')?.touched)"
                                            class="text-danger">
                                            <!-- You might not need validation here since the field is read-only -->
                                            Enter Correct Job Name

                                        </div>
                                    </div>
                                </div>
                                <div class="row">


                                    <div class="col form-group mb-3">
                                        <label for="coilWidth" class="form-label">Coil Width</label>
                                        <input type="text" formControlName="coilWidth" id="coilWidth"
                                            class="form-control" readonly placeholder="Coil Width" disabled />
                                        <div *ngIf="updateJssForm.get('coilWidth')?.invalid && (updateJssForm.get('coilWidth')?.dirty || updateJssForm.get('coilWidth')?.touched)"
                                            class="text-danger">
                                            <!-- Add specific validation messages if needed -->
                                        </div>
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="coilod" class="form-label">Coil OD</label>
                                        <input type="text" formControlName="coilod" id="coilod" class="form-control"
                                            readonly placeholder="Coil OD" disabled />
                                        <div *ngIf="updateJssForm.get('coilod')?.invalid && (updateJssForm.get('coilod')?.dirty || updateJssForm.get('coilod')?.touched)"
                                            class="text-danger">
                                            <!-- Add specific validation messages if needed -->
                                        </div>
                                    </div>


                                    <div class="col form-group mb-3">
                                        <label for="pouch" class="form-label">Pouch Wt/Pcs</label>
                                        <input type="text" formControlName="pouch" id="pouch" class="form-control"
                                            placeholder="Pouch Wt/Pcs" readonly disabled />
                                    </div>

                                    <div class="col form-group mb-3">
                                        <label for="jssfolderno" class="form-label">JSS Folder No.</label>
                                        <input type="text" formControlName="jssfolderno" id="jssfolderno"
                                            class="form-control" placeholder="Enter JSS Folder No." />
                                        <!-- <div *ngIf="updateJssForm.get('jssfolderno')?.invalid && (updateJssForm.get('jssfolderno')?.touched || updateJssForm.get('jssfolderno')?.dirty)" class="text-danger">
                                                <div *ngIf="updateJssForm.get('jssfolderno')?.errors?.required">JSS Folder No. is required.</div>
                                            </div> -->
                                        <div *ngIf="updateJssForm.get('jssfolderno')?.invalid && (updateJssForm.get('jssfolderno')?.dirty || updateJssForm.get('jssfolderno')?.touched)"
                                            class="text-danger">
                                            <div *ngIf="updateJssForm.get('jssfolderno')?.errors?.required">First Name
                                                is required.</div>
                                            <div *ngIf="updateJssForm.get('jssfolderno')?.errors?.pattern">First Name
                                                must contain only letters.</div>
                                        </div>
                                    </div>


                                    <!-- <div class="col form-group mb-3">
                                        <label for="printDirection" class="form-label">Print Direction</label>
                                <input type="text" formControlName="printDirection" id="printDirection" class="form-control" />
                                    </div> -->

                                </div>
                                <div class="row">





                                    <div class="col form-group mb-3">
                                        <label for="coreType" class="form-label">Core Type</label>
                                        <div class="input-group">
                                            <select formControlName="coreType" id="coreType"
                                                class="form-control minimal">
                                                <option value="" disabled Selected>Select Core Type</option>
                                                <option value="PaperPipe">Paper Pipe</option>
                                                <option value="PVCPipe">PVC Pipe</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col form-group mb-3">
                                        <label for="LamType" class="form-label">Lamination Type</label>
                                        <div class="input-group">
                                            <select formControlName="LamType" id="LamType" class="form-control minimal">
                                                <option value="" disabled selected>Select Lam Type</option>
                                                <option value="base">Base</option>
                                                <option value="less">Less</option>
                                                <option value="NA">NA</option>
                                            </select>
                                            <div *ngIf="updateJssForm.get('LamType')?.invalid && (updateJssForm.get('LamType')?.dirty || updateJssForm.get('LamType')?.touched)"
                                                class="text-danger">
                                                <div *ngIf="updateJssForm.get('LamType')?.errors?.required">Lamination
                                                    Type is required.</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col form-group mb-3">
                                        <label for="printType" class="form-label">Print Type</label>
                                        <div class="d-flex">
                                            <input type="text" formControlName="printType" id="printType"
                                                class="form-control" placeholder="Print Type" />
                                            <div *ngIf="updateJssForm.get('printType')?.invalid && (updateJssForm.get('printType')?.dirty || updateJssForm.get('printType')?.touched)"
                                                class="text-danger">
                                                <div *ngIf="updateJssForm.get('printType')?.errors?.required">Print Type
                                                    is required.</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col form-group mb-3">
                                        <label for="repeatLength" class="form-label">Repeat Length</label>
                                        <input type="text" formControlName="repeatLength" id="repeatLength"
                                            class="form-control" placeholder="Repeat Length" />
                                        <div *ngIf="updateJssForm.get('repeatLength')?.invalid && (updateJssForm.get('repeatLength')?.dirty || updateJssForm.get('repeatLength')?.touched)"
                                            class="text-danger">
                                            <div *ngIf="updateJssForm.get('repeatLength')?.errors?.required">Repeat
                                                Length is required.</div>
                                            <!-- Add other specific validation messages if needed -->
                                        </div>
                                    </div>


                                </div>
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="std" class="form-label">STD. INK GSM</label>
                                        <input type="text" formControlName="std" id="std" class="form-control"
                                            placeholder="STD. INK GSM" />
                                        <div *ngIf="updateJssForm.get('std')?.invalid && (updateJssForm.get('std')?.dirty || updateJssForm.get('std')?.touched)"
                                            class="text-danger">
                                            <div *ngIf="updateJssForm.get('std')?.errors?.required">STD. INK GSM is
                                                required.</div>
                                        </div>
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="std" class="form-label">Liquid Ink</label>
                                        <input type="text" formControlName="liquid" id="liquid" class="form-control"
                                            placeholder="Liquid Ink" />
                                        <div *ngIf="updateJssForm.get('liquid')?.invalid && (updateJssForm.get('liquid')?.dirty || updateJssForm.get('liquid')?.touched)"
                                            class="text-danger">
                                            <div *ngIf="updateJssForm.get('liquid')?.errors?.required">Liquid Ink GSM is
                                                required.</div>
                                        </div>
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="std" class="form-label">Ink Type</label>
                                        <input type="text" formControlName="inkType" id="inkType" class="form-control"
                                            placeholder="Ink Type" />
                                        <div *ngIf="updateJssForm.get('matCode')?.invalid && (updateJssForm.get('matCode')?.dirty || updateJssForm.get('matCode')?.touched)"
                                            class="text-danger">
                                            <div *ngIf="updateJssForm.get('matCode')?.errors?.required">Material Code is
                                                required.</div>
                                        </div>
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="printDirection" class="form-label">Print Direction</label>
                                        <input type="text" formControlName="printDirection" id="printDirection"
                                            class="form-control" placeholder="Print Direction" />
                                    </div>

                                </div>
                                <div class="row">

                                    <div class="col form-group mb-3">
                                        <label for="totalGsm" class="form-label">TOTAL GSM</label>
                                        <input type="text" formControlName="totalGsm" id="totalGsm" class="form-control"
                                            placeholder="TOTAL GSM" />
                                    </div>

                                    <div class="col form-group mb-3">
                                        <label for="colorNames" class="form-label">Color Names</label>
                                        <input type="text" formControlName="colorNames" id="colorNames"
                                            class="form-control" placeholder="Eneter Color Names" />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="colorNumber" class="form-label">No. of Colors</label>
                                        <select formControlName="colorNumber" id="colorNumber"
                                            class="form-control minimal">
                                            <option value="" disabled Selected>Select No. of Colors</option>
                                            <option value="0">0</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                            <option value="9">9</option>
                                        </select>

                                    </div>

                                </div>

                                <div class="row">

                                    <div class="col form-group mb-3">
                                        <div formGroupName="cylinders">
                                            <label for="cylinders" class="form-label">Cylinders</label>

                                            <div class=" row d-flex">
                                                <div class="col form-group mb-3">
                                                    <label class="form-label">Cylinder ID</label>
                                                    <input type="text" formControlName="id" id="id" class="form-control"
                                                        placeholder="0" />
                                                </div>
                                                <div class="col form-group mb-3">
                                                    <label class="form-label">Cylinder Supplier</label>
                                                    <input type="text" formControlName="supplier" id="supplier"
                                                        class="form-control" placeholder="0" />
                                                </div>
                                                <div class="col form-group mb-3">
                                                    <label class="form-label">Face Length</label>
                                                    <input type="text" formControlName="length" id="length"
                                                        class="form-control" placeholder="0" />
                                                </div>
                                                <div class="col form-group mb-3">
                                                    <label class="form-label">Cylinder Circumference</label>
                                                    <input type="text" formControlName="circumference"
                                                        id="circumference" class="form-control" placeholder="0" />
                                                </div>
                                                <div class="col form-group mb-3">
                                                    <label class="form-label">Cylinder Location</label>
                                                    <input type="text" formControlName="location" id="location"
                                                        class="form-control" placeholder="0" />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="row">
                                    <div formArrayName="materials">
                                        <div *ngFor="let material of materials.controls; let i = index"
                                            [formGroupName]="i" class="row">
                                            <div class="col form-group mb-3">
                                                <label for="material" class="form-label">Material</label>
                                                <select formControlName="material" id="material" class="form-select">
                                                    <option value="" disabled>Select Material</option>
                                                    <option value="CLEAR BOPP">CLEAR BOPP</option>
                                                    <option value="MET BOPP">MET BOPP</option>
                                                    <option value="PEARL BOPP">PEARL BOPP</option>
                                                    <option value="MATT BOPP">MATT BOPP</option>
                                                    <option value="CLEAR PET">CLEAR PET</option>
                                                    <option value="CT PET">CT PET</option>
                                                    <option value="CLEAR PP">CLEAR PP</option>
                                                    <option value="CC PET">CC PET</option>
                                                    <option value="CT+CC PET">CT+CC PET</option>
                                                    <option value="SHRINK PET (PETG)">SHRINK PET (PETG)</option>
                                                    <option value="MET PET">MET PET</option>
                                                    <option value="MATT PET">MATT PET</option>
                                                    <option value="PVC TWIST CLEAR">PVC TWIST CLEAR</option>
                                                    <option value="PVC SHRINK">PVC SHRINK</option>
                                                    <option value="PVC TWIST ORANGE">PVC TWIST ORANGE</option>
                                                    <option value="CPP MET">CPP MET</option>
                                                    <option value="CPP CLEAR">CPP CLEAR</option>
                                                    <option value="LDPE -SHRINK">LDPE -SHRINK</option>
                                                    <option value="LDPE LAMINATION">LDPE LAMINATION</option>
                                                    <option value="LDPE CLEAR">LDPE CLEAR</option>
                                                    <option value="LDPE WHITE">LDPE WHITE</option>
                                                    <option value="FOIL ALU">FOIL ALU</option>
                                                    <option value="HDPE CLEAR">HDPE CLEAR</option>
                                                    <option value="WIP">WIP</option>
                                                </select>
                                            </div>
                                            <div class="col form-group mb-3">
                                                <label class="form-label" for="thickness">Thickness (µ)</label>
                                                <input type="text" formControlName="thickness" id="thickness"
                                                    class="form-control" />
                                            </div>
                                            <div class="col form-group mb-3">
                                                <label class="form-label" for="width">Width(mm)</label>
                                                <input type="text" formControlName="width" id="width"
                                                    class="form-control" />
                                            </div>
                                            <div class="col form-group mb-3">
                                                <label class="form-label" for="process">Process</label>
                                                <select class="form-control" id="process"
                                                    formControlName="selectedProcess">
                                                    <option value="" selected>--Select Process--</option>
                                                    <option value="EXTRUSION">EXTRUSION</option>
                                                    <option value="PRINTING">PRINTING</option>
                                                    <option value="LAMINATION">LAMINATION</option>
                                                    <option value="SLITTING">SLITTING</option>
                                                    <option value="CUTTING">CUTTING</option>
                                                    <option value="PACKING">PACKING</option>
                                                    <option value="DISPATCH">DISPATCH</option>
                                                    <option value="GLUEING">GLUEING</option>
                                                </select>
                                            </div>
                                            <button type="button" class="btn btn-danger colb form-group mb-3"
                                                (click)="removeMaterial(i)">Remove</button>
                                        </div>
                                    </div>


                                    <div class="col form-group mb-3">
                                        <button type="button" class="btn btn-primary col form-group mb-3 btn-add"
                                            (click)="addMaterial()">+ Material</button>
                                    </div>

                                </div>


                                <button type="submit" class="btn btn-outline-dark"
                                    [disabled]="updateJssForm.invalid">Save JSS</button>
                            </form>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>